const yodaCoreComponents = {
    Text: {
        importFn: () => import('yodaCoreComponents/Text'),
        path: 'yodaCoreComponents/Text',
        type: 'functional',
        isSSR: false,
    },
};

module.exports = { yodaCoreComponents };
